import React from 'react';
import {TouchableOpacity} from 'react-native';

const upadateFirebaseEvent = props => {
  if (props.nativeID) {
    // console.log('firbase button', props.nativeID);
  }

  if (props.onPress) {
    setTimeout(() => {
      props.onPress();
    }, 70);
  }
};

function CustomTouchableOpacity(props) {
  return <TouchableOpacity {...props} onPress={() => upadateFirebaseEvent(props)}></TouchableOpacity>;
}

export default CustomTouchableOpacity;
